import React, { Fragment, useState, useEffect } from 'react';
// @material-ui/core components
//import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import AddAlert from '@material-ui/icons/AddAlert';
// core components
import Snackbar from '../UI/Snackbar/Snackbar';

//import notificationsStyles from '../../assets/jss/react-app/views/notificationsStyle';

//const useStyles = makeStyles(notificationsStyles);

const Notification = (props) => {
  //const classes = useStyles();
  const [tl, setTL] = useState(false);
  const [tc, setTC] = useState(false);
  const [tr, setTR] = useState(false);
  const [bl, setBL] = useState(false);
  const [bc, setBC] = useState(false);
  const [br, setBR] = useState(false);

  useEffect(() => {
    if (props.mostrar) {
      showNotification('br');
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      // to stop the warning of calling setState of unmounted component
      var id = window.setTimeout(null, 0);
      while (id--) {
        window.clearTimeout(id);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showNotification = (place) => {
    switch (place) {
      case 'tl':
        if (!tl) {
          setTL(true);
          setTimeout(function () {
            setTL(false);
          }, 4000);
        }
        break;
      case 'tc':
        if (!tc) {
          setTC(true);
          setTimeout(function () {
            setTC(false);
          }, 4000);
        }
        break;
      case 'tr':
        if (!tr) {
          setTR(true);
          setTimeout(function () {
            setTR(false);
          }, 4000);
        }
        break;
      case 'bl':
        if (!bl) {
          setBL(true);
          setTimeout(function () {
            setBL(false);
          }, 4000);
        }
        break;
      case 'bc':
        if (!bc) {
          setBC(true);
          setTimeout(function () {
            setBC(false);
          }, 4000);
        }
        break;
      case 'br':
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
          }, 4000);
        }
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <Snackbar
        place='br'
        color={
          props.stt === 'fail' || props.stt === 'error' ? 'danger' : 'success'
        }
        icon={AddAlert}
        message={props.msg}
        open={br}
        closeNotification={() => setBR(false)}
        close
      />
    </Fragment>
  );
};

export default Notification;
